import React, { useEffect, createElement } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { SalesPage } from './pages/SalesPage';
import { UpsellPage } from './pages/UpsellPage';
import { ThankYouPage } from './pages/ThankYouPage';
export function App() {
  useEffect(() => {
    // UTMify UTMs script
    const utmifyScript = document.createElement('script');
    utmifyScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmifyScript.setAttribute('data-utmify-prevent-subids', '');
    utmifyScript.async = true;
    utmifyScript.defer = true;
    document.head.appendChild(utmifyScript);
    (window as any).pixelId = '69a84f432f2498111cab00d3';
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.defer = true;
    pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    document.head.appendChild(pixelScript);
    // Google tag (gtag.js)
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-H6W0NPCL3K';
    document.head.appendChild(gtagScript);
    const gtagInline = document.createElement('script');
    gtagInline.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-H6W0NPCL3K');
    `;
    document.head.appendChild(gtagInline);
    return () => {
      document.head.removeChild(utmifyScript);
      document.head.removeChild(pixelScript);
      document.head.removeChild(gtagScript);
      document.head.removeChild(gtagInline);
    };
  }, []);
  return <HashRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<SalesPage data-id="element-3" />} data-id="element-2" />
        <Route path="/up1" element={<UpsellPage data-id="element-5" />} data-id="element-4" />
        <Route path="/thankyou1" element={<ThankYouPage data-id="element-7" />} data-id="element-6" />
      </Routes>
    </HashRouter>;
}